import { render, staticRenderFns } from "./TabPutAway.vue?vue&type=template&id=09c583b0"
import script from "./TabPutAway.vue?vue&type=script&lang=js"
export * from "./TabPutAway.vue?vue&type=script&lang=js"
import style0 from "./TabPutAway.vue?vue&type=style&index=0&id=09c583b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports